export default {
    // TODO save the currencies as an array in config.yml. Then import them here and in getCurrencySymbol of EasyFixService.php
    symbol(country){
        switch(country) {
            case 'UK':
                return '£';
            case 'DK':
                return 'kr.';
            case 'PL':
                return 'zł';
            case 'SE':
                return 'kr';
            case 'US':
                return '$';
            case 'NO':
                return 'kr';
            default:
                return '€'
        }
    }
}
